export default "__VITE_ASSET__BLJF96mV__"